import { type Breakpoints } from '@bygghemmait/theme';
import { type HeaderState } from 'models/HeaderState';
import { MediaQuery } from 'models/MediaQueryService';
import {
  currentBreakpointDesktop,
  currentBreakpointHuge,
  currentBreakpointLarge,
  currentBreakpointPhone,
  currentBreakpointSmall,
  currentBreakpointTablet,
  currentBreakpointUltra
} from './actions';

/**
 * IMPORTANT: These sizes must match $breakpoints @ src/styles/config/responsive.scss
 */
const MEDIAQUERY_SIZES = {
  phone: 320,
  tablet: 768,
  large: 1024,
  desktop: 1128,
  huge: 1500,
  ultra: 1920
} as const;

const unit = 'px';
const step = 1;
export const queries = {
  [`(max-width: ${MEDIAQUERY_SIZES.phone - step}${unit})`]: currentBreakpointSmall,
  [`(min-width: ${MEDIAQUERY_SIZES.phone}${unit}) and (max-width: ${
    MEDIAQUERY_SIZES.tablet - step
  }${unit})`]: currentBreakpointPhone,
  [`(min-width: ${MEDIAQUERY_SIZES.tablet}${unit}) and (max-width: ${
    MEDIAQUERY_SIZES.large - step
  }${unit})`]: currentBreakpointTablet,
  [`(min-width: ${MEDIAQUERY_SIZES.large}${unit}) and (max-width: ${
    MEDIAQUERY_SIZES.desktop - step
  }${unit})`]: currentBreakpointLarge,
  [`(min-width: ${MEDIAQUERY_SIZES.desktop}${unit}) and (max-width: ${
    MEDIAQUERY_SIZES.huge - step
  }${unit})`]: currentBreakpointDesktop,
  [`(min-width: ${MEDIAQUERY_SIZES.huge}${unit}) and (max-width: ${
    MEDIAQUERY_SIZES.ultra - step
  }${unit})`]: currentBreakpointHuge,
  [`(min-width: ${MEDIAQUERY_SIZES.ultra}${unit})`]: currentBreakpointUltra
} as const;

const mqToBreakpointMap: Record<number, Breakpoints> = {
  [MediaQuery.Small]: 'base',
  [MediaQuery.Phone]: 'xs',
  [MediaQuery.Tablet]: 'sm',
  [MediaQuery.Large]: 'md',
  [MediaQuery.Desktop]: 'lg',
  [MediaQuery.Huge]: 'xl',
  [MediaQuery.Ultra]: 'xxl'
};
export function gecpMqHandler(state: HeaderState): Breakpoints {
  return mqToBreakpointMap[state.currentBreakpoint];
}
